import request from '@/utils/request'

export function getMaterialList(params) {
  return request({
    url: '/marketing_assets/images',
    method: 'get',
    params
  })
}

export function getMaterialList1(params) {
  return request({
    url: '/marketing_assets/source_materials',
    method: 'get',
    params
  })
}

export function getNativePageList(params) {
  return request({
    url: '/marketing_assets/native_pages',
    method: 'get',
    params
  })
}

export function getWechatNativePAGE(params) {
  return request({
    url: '/marketing_assets/page_templates',
    method: 'get',
    params
  })
}

export function getNative_accounts(params) {
  return request({
    url: '/marketing_assets/native_accounts',
    method: 'get',
    params
  })
}

export function deleteNative_accounts(id, body) {
  return request({
    url: `/marketing_assets/native_accounts/${id}`,
    method: 'DELETE',
    data: body
  })
}

export function deletePcileNative(id) {
  return request({
    url: `/marketing_assets/native_pages/${id}`,
    method: 'DELETE'
  })
}

export function createAcc(data) {
  return request({
    url: '/marketing_assets/native_accounts',
    method: 'post',
    data
  })
}
